var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "ct-offcanvas-panel map-add-feature-panel",
      style: { "margin-bottom": _vm.panelBottom },
    },
    [
      !_vm.isActionNewOccurrence
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-rounded btn-responsive btn-lg btn-tertiary-main btn-add-feature",
              attrs: { type: "button", disabled: _vm.isActionNewOccurrence },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onStartProcess.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.txtAddTitleButton) + "\n    ")]
          )
        : [
            _c("DrawAndUpload", {
              attrs: {
                idPanel: _vm.idPanel,
                moduleCode: _vm.moduleCode,
                panelCfg: _vm.panelTool,
                url: _vm.url,
                acl: _vm.acl,
                map: _vm.map,
                drawTypes: _vm.drawTypes,
                enableDraw: _vm.enableDraw,
                enableImport: _vm.enableImport,
                uploadMsgClass: "small",
              },
              on: {
                onConfirm: _vm.onConfirmGeometry,
                onCancel: _vm.onCancelProcess,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }